import { EmployeeAvatar } from "@/components/employee/EmployeeAvatar.tsx";
import useFormatter from "@/hooks/use-formatter.hook.ts";
import { EmployeeViewModal } from "@/pages/employees/widgets/EmployeeViewModal.tsx";
import { ApiEmployee } from "@/types/employees/employee.types.ts";
import { Stack, Title, useModals } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

interface SurveyTargetEmployeeProps {
  employee: ApiEmployee;
  className?: string;
}

export const SurveyTargetEmployee = ({ employee, className }: SurveyTargetEmployeeProps) => {
  const { t } = useTranslation();
  const { renderEmployeeName } = useFormatter();
  const { openModal } = useModals();

  return (
    <Stack
      gap={"smd"}
      items={"start"}
      className={twMerge("cursor-pointer", className)}
      onClick={() => {
        openModal(EmployeeViewModal, { employee });
      }}
    >
      <EmployeeAvatar employee={employee} size={"2xl"} />
      <Title
        header={t("scorecards:show_profile", {
          applicant: renderEmployeeName(employee),
        })}
        className={"max-w-40"}
      />
    </Stack>
  );
};
